import { isValidElement } from 'react';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';

function isPrimitive(arg) {
  const type = typeof arg;

  return arg == null || (type !== 'object' && type !== 'function');
}

const createErrObj = (field, msg) => ({
  field,
  msg,
});

const getFields = (errors, useRHFName) => {
  const ret = [];

  // eslint-disable-next-line no-use-before-define
  proceed(errors, '');

  return ret;

  function updateLevel(level, errName) {
    let levelString = `${level}.${errName}`;
    if (levelString.startsWith('.')) {
      levelString = levelString.substring(1);
    }

    return levelString;
  }

  function iterate(err, errName, currentLevel) {
    if (isPrimitive(err) || isValidElement(err)) {
      ret.push(createErrObj(updateLevel(currentLevel, errName), err));
    } else if (isArray(err)) {
      // eslint-disable-next-line no-param-reassign
      currentLevel = updateLevel(currentLevel, errName);
      err.forEach((error, idx) => {
        const field = useRHFName ? `${currentLevel}.${idx}` : `${currentLevel}[${idx}]`;
        if (isPrimitive(error)) {
          ret.push(createErrObj(field, error));
        } else {
          // eslint-disable-next-line no-use-before-define
          proceed(error, field);
        }
      });
    } else if (isObject(err)) {
      // eslint-disable-next-line no-use-before-define
      proceed(err, updateLevel(currentLevel, errName));
    }
  }

  function proceed($errors = {}, currentLevel) {
    Object.keys($errors).forEach((name) => {
      iterate($errors[name], name, currentLevel);
    });
  }
};

export default getFields;
